// extracted by mini-css-extract-plugin
export default {"root":"sdKVHkte","aside":"k4Rzpa2F","root__mobile":"AEyq8Gk8","icon":"ubo7ebNL"};